// ABOUTME: Per-widget role visibility of custom page widgets (config.roles).
// ABOUTME: No roles list, or an empty one, means visible to everyone; otherwise at least one role must match.

export function isWidgetVisibleForRoles(
    config: Record<string, unknown> | null | undefined,
    hasUserRole: (role: string) => boolean,
): boolean {
    const roles = config?.roles;
    if (!Array.isArray(roles) || roles.length === 0) return true;
    // A non-empty list never falls back to "everyone": malformed entries simply never match.
    return roles.some(role => typeof role === 'string' && role.length > 0 && hasUserRole(role));
}
